<template>
  <modal title="Search Results" size="lg" ref="modal">
    <post-search-loader :post-search-id="postSearchId" v-model="postSearch" />
    <post-search v-if="postSearch" :post-search="postSearch" />
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import { PostSearch as PostSearchType } from '@/type';
import Modal from '@/components/modal/Modal.vue';
import PostSearch from './PostSearch.vue';
import PostSearchLoader from './PostSearchLoader.vue';

interface Data {
  postSearch: PostSearchType|null,
}

export default defineComponent({
  mixins: [ModalMixin],
  components: {
    PostSearchLoader,
    Modal,
    PostSearch,
  },
  props: {
    postSearchId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      postSearch: null,
    };
  },
});
</script>
